import { FC, HTMLProps } from 'react';

import ConflictIcon from '@/domain/conflict/ConflictIcon';
import {
  conflictSoortOmschrijving,
  conflictSoortTooltip,
  geefDienstregelpuntVoorConflict,
  geefInzetVoorConflict,
  geefPerronSpoorVoorConflict,
  geefTijdstipVoorConflict,
} from '@/domain/conflict/conflictUtils';
import { Conflict } from '@/types/Conflicten';
import { dayOfWeekWithTime } from '@/utils/dateUtils';

import styles from './TooltipConflictRow.module.css';

const TooltipConflictRow: FC<
  {
    conflict: Conflict;
  } & HTMLProps<HTMLDivElement>
> = ({ conflict }) => {
  return (
    <div className={styles.conflictRowContainer}>
      <div className={styles.conflictRow}>
        <ConflictIcon tooltip type={conflict.type} />
        <div className={styles.conflictSoort} title={conflictSoortTooltip(conflict.type)}>
          {conflictSoortOmschrijving(conflict.type)}
        </div>
        <div className={styles.inzetStyleTooltip}>
          {/* Perronlengte conflicten verkrijgen op dit moment nog geen inzetpositie */}
          {geefInzetVoorConflict(conflict)}
        </div>
        <div>
          {geefDienstregelpuntVoorConflict(conflict)} {geefPerronSpoorVoorConflict(conflict, 'tooltip')}
        </div>
      </div>
      <div className={styles.timeDiv}>
        <span className={styles.timeSpan}>{dayOfWeekWithTime(geefTijdstipVoorConflict(conflict))}</span>
      </div>
    </div>
  );
};

export default TooltipConflictRow;
